import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PortalCapacitySection = ({
  portalCapacityLoad,
  portalCapacityLimit
}) => {
  const isAtOrOverCapacity = portalCapacityLoad >= portalCapacityLimit;
  return /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitLiveChat",
        options: {
          portalCapacityLoad,
          portalCapacityLimit
        }
      }), isAtOrOverCapacity && /*#__PURE__*/_jsx(Small, {
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.atChatCapacityDescription"
        })
      })]
    })
  });
};
PortalCapacitySection.displayName = 'PortalCapacitySection';